export enum ViewGridToolbarGroupFileActionsBlock {
  Root = 'ViewGridToolbarGroupFileActions',
}
